import apiService, { buildQueryString } from './api';
class ProdutosService {
    // Listar produtos
    async list(filters = {}) {
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/produtos${queryString}`);
        return response.data;
    }
    // Buscar produto por ID
    async getById(id) {
        const response = await apiService.get(`/produtos/${id}`);
        return response.data;
    }
    // Criar produto
    async create(data) {
        const response = await apiService.post('/produtos', data);
        return response.data;
    }
    // Atualizar produto
    async update(id, data) {
        const response = await apiService.put(`/produtos/${id}`, data);
        return response.data;
    }
    // Deletar produto
    async delete(id) {
        await apiService.delete(`/produtos/${id}`);
    }
    // Buscar por código (SKU ou código de barras)
    async buscarPorCodigo(codigo) {
        const response = await apiService.get(`/produtos/codigo/${codigo}`);
        return response.data;
    }
    // Obter categorias
    async getCategorias() {
        const response = await apiService.get('/produtos/categorias');
        return response.data;
    }
    // Obter estatísticas
    async getStats() {
        const response = await apiService.get('/produtos/stats');
        return response.data;
    }
    // Movimentar estoque
    async movimentarEstoque(data) {
        const response = await apiService.post(`/produtos/${data.produtoId}/movimentar`, data);
        return response.data;
    }
    // Exportar produtos
    async exportar(format, filters = {}) {
        const queryString = buildQueryString({ ...filters, format });
        await apiService.download(`/produtos/export${queryString}`, `produtos.${format}`);
    }
    // Gerar etiqueta com QR Code
    async gerarEtiqueta(id) {
        await apiService.download(`/produtos/${id}/etiqueta`, `produto-${id}-etiqueta.pdf`);
    }
    // Buscar produtos com estoque baixo
    async getProdutosEstoqueBaixo() {
        const response = await apiService.get('/produtos?estoqueMinimo=true&limit=100');
        return response.data.produtos;
    }
    // Buscar produtos sem estoque
    async getProdutosSemEstoque() {
        const response = await apiService.get('/produtos?estoqueZerado=true&limit=100');
        return response.data.produtos;
    }
    // Buscar produtos por categoria
    async getProdutosPorCategoria(categoria) {
        const response = await apiService.get(`/produtos?categoria=${categoria}&limit=100`);
        return response.data.produtos;
    }
    // Verificar disponibilidade de estoque
    async verificarEstoque(produtoId, quantidade) {
        const produto = await this.getById(produtoId);
        return {
            disponivel: produto.stockAtual >= quantidade,
            estoqueAtual: produto.stockAtual
        };
    }
    // Buscar peças para orçamentos (pesquisa ao vivo)
    async searchPecas(search) {
        if (!search.trim())
            return [];
        const response = await apiService.get(`/produtos?search=${encodeURIComponent(search)}&tipo=PECA&limit=20`);
        return response.data.produtos;
    }
    // Buscar produtos por tipo (para orçamentos)
    async searchByTipo(search, tipo) {
        if (!search.trim())
            return [];
        const response = await apiService.get(`/produtos?search=${encodeURIComponent(search)}&tipo=${tipo}&limit=20`);
        return response.data.produtos;
    }
}
// Instância singleton
const produtosService = new ProdutosService();
export default produtosService;
// Utilitários
export const tiposMovimentacao = [
    { value: 'ENTRADA', label: 'Entrada', color: 'green', icon: '↗️' },
    { value: 'SAIDA', label: 'Saída', color: 'red', icon: '↙️' },
    { value: 'AJUSTE', label: 'Ajuste', color: 'blue', icon: '⚖️' }
];
export const getTipoMovimentacaoConfig = (tipo) => {
    return tiposMovimentacao.find(t => t.value === tipo) || tiposMovimentacao[0];
};
export const formatarTipoMovimentacao = (tipo) => {
    const config = getTipoMovimentacaoConfig(tipo);
    return config.label;
};
export const getTipoMovimentacaoColor = (tipo) => {
    const config = getTipoMovimentacaoConfig(tipo);
    return config.color;
};
export const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: 'EUR'
    }).format(valor);
};
export const formatarQuantidade = (quantidade) => {
    return new Intl.NumberFormat('pt-PT').format(quantidade);
};
export const calcularMargemLucro = (precoCusto, precoVenda) => {
    if (precoCusto === 0)
        return 0;
    return ((precoVenda - precoCusto) / precoCusto) * 100;
};
export const calcularPrecoVenda = (precoCusto, margemLucro) => {
    return precoCusto * (1 + (margemLucro / 100));
};
export const formatarPorcentagem = (valor) => {
    return new Intl.NumberFormat('pt-PT', {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 2
    }).format(valor / 100);
};
export const getStatusEstoque = (produto) => {
    if (produto.stockAtual === 0) {
        return { status: 'zerado', color: 'red', label: 'Sem estoque' };
    }
    if (produto.stockAtual <= produto.stockMinimo) {
        return { status: 'baixo', color: 'yellow', label: 'Estoque baixo' };
    }
    return { status: 'normal', color: 'green', label: 'Estoque normal' };
};
export const validarSKU = (sku) => {
    // SKU deve ter entre 3 e 20 caracteres, apenas letras, números e hífens
    const regex = /^[A-Za-z0-9\-]{3,20}$/;
    return regex.test(sku);
};
export const validarCodigoBarras = (codigo) => {
    // Validação básica para códigos de barras (EAN-8, EAN-13, UPC)
    const regex = /^[0-9]{8}$|^[0-9]{12,13}$/;
    return regex.test(codigo);
};
export const gerarSKU = (nome, categoria) => {
    const nomeClean = nome.replace(/[^A-Za-z0-9]/g, '').substring(0, 6).toUpperCase();
    const categoriaClean = categoria.replace(/[^A-Za-z0-9]/g, '').substring(0, 3).toUpperCase();
    const timestamp = Date.now().toString().slice(-4);
    return `${categoriaClean}-${nomeClean}-${timestamp}`;
};
